import { CorporateDesignPageComponent } from './pages/cms/corporate-design/corporate-design-page.component';
import { LICENSE_KEYS, EConfigurationChannel } from '@web/dtos';
import { Route } from '@angular/router';
import { LandingPageComponent } from './pages/shop/landing/landing-page.component';
import { HeaderPageComponent } from './pages/cms/header/header-page.component';
import { FooterPageComponent } from './pages/cms/footer/footer-page.component';
import { CmsPageComponent } from './pages/cms/cms-page.component';
import { ShopPageComponent } from './pages/shop/shop-page.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { ImagePageComponent } from './pages/cms/image/image-page.component';
import { FormInputsDisplayComponent } from './components/data-input/form-inputs-display/form-inputs-display.component';
import { PageNotFoundComponent } from './pages/shop/page-not-found/page-not-found.component';
import { FooterFormChangedGuard } from './guards/footer-form-changed.guard';
import { BannerPageComponent } from './pages/cms/banner/banner-page.component';
import { BannerFormChangedGuard } from './guards/banner-form-changed.guard';
import { HeaderFormChangedGuard } from './guards/header-form-changed.guard';
import { AccountPageComponent } from './pages/shop/account/account-page/account-page.component';
import { UserIsAdminGuard } from './guards/user-is-admin.guard';
import { UserIsCmsUserGuard } from './guards/user-is-cms-user.guard';
import { CmsAccessDeniedPageComponent } from './pages/access-denied-page/cms-access-denied-page.component';
import { ConfigurationPageComponent } from './pages/cms/configuration/configuration-page.component';
import { ConfigurationFormChangedGuard } from './guards/configuration-form.guard';
import { AccountInfoPageComponent } from './pages/shop/account/account-info-page/account-info-page.component';
import { AccountDeletePageComponent } from './pages/shop/account/account-delete-page/account-delete-page.component';
import { AccountPaymentPageComponent } from './pages/shop/account/account-payment-page/account-payment-page.component';
import { userIsAuthenticatedGuard } from './guards/user-is-authenticated.guard';
import { SubscriptionTicketsPageComponent } from './pages/shop/subscription-tickets-page/subscription-tickets-page.component';
import { DirectTicketsPageComponent } from './pages/shop/direct-tickets-page/direct-tickets-page.component';
import { ButtonDisplayComponent } from './components/feedback/button-display/button-display.component';
import { DirectTicketConfigurationPageComponent } from './pages/shop/direct-ticket-configuration-page/direct-ticket-configuration-page.component';
import { TextsForWebPageComponent } from './pages/cms/texts-for-web/texts-for-web-page.component';
import { DirectTicketOptionConfigurationPage } from './pages/shop/direct-ticket-configuration-page/direct-ticket-option-configuration-page/direct-ticket-option-configuration-page.component';
import { DirectTicketPersonalDataPageComponent } from './pages/shop/direct-ticket-configuration-page/direct-ticket-personal-data-page/direct-ticket-personal-data-page.component';
import { DirectTicketOwnerDataPageComponent } from './pages/shop/direct-ticket-configuration-page/direct-ticket-owner-data-page/direct-ticket-owner-data-page.component';
import { DirectTicketCheckoutPageComponent } from './pages/shop/direct-ticket-configuration-page/direct-ticket-checkout-page/direct-ticket-checkout-page.component';
import { DirectTicketPaymentPageComponent } from './pages/shop/direct-ticket-configuration-page/direct-ticket-payment-page/direct-ticket-payment-page.component';
import { LanguagePageComponent } from './pages/cms/language/language-page.component';
import { UserFeedbackPageComponent } from './pages/cms/user-feedback/user-feedback-page.component';
import { IncidentMonitorPageComponent } from './pages/cms/incident-monitor/incident-monitor-page.component';
import { SubscriptionConfigurationPageComponent } from './pages/shop/subscription-configuration-page/subscription-configuration-page.component';
import { SubscriptionOptionConfigurationPage } from './pages/shop/subscription-configuration-page/subscription-option-configuration-page/subscription-option-configuration-page.component';
import { SubscriptionMaskStepComponent } from './pages/shop/subscription-configuration-page/subscription-option-configuration-page/subscription-mask-step/subscription-mask-step.component';
import { SubscriptionPaymentStepComponent } from './pages/shop/subscription-configuration-page/subscription-option-configuration-page/subscription-payment-step/subscription-payment-step.component';
import { LanguageFormChangedGuard } from './guards/language-form-changed.guard';
import { WebTextsFormChangedGuard } from './guards/web-texts-form-changed.guard';
import { AccountOrdersPageComponent } from './pages/shop/account/account-orders-page/account-orders-page.component';
import { OrdersPageComponent } from './pages/cms/orders/orders-page.component';
import { UsersPageComponent } from './pages/cms/users/users-page.component';
import { ERoute } from './constants/routes.enum';
import { StartPageComponent } from './pages/cms/startPage/start-page.component';
import { StartPageFormChangedGuard } from './guards/start-page-form-changed.guard';
import { StartPageCardEditPageComponent } from './pages/cms/startPage/start-page-card-block/start-page-card-edit-page/start-page-card-edit-page.component';
import { StartPageEditCardFormChangedGuard } from './guards/start-page-card-edit-changed.guard';
import { TextsForAppComponent } from './pages/cms/texts-for-app/texts-for-app.component';
import { AppTextsFormChangedGuard } from './guards/app-texts-form-changed.guard';
import { ShoppingCartPageComponent } from './pages/cms/shopping-cart/shopping-cart-page.component';
import { ShoppingCartFormChangedGuard } from './guards/shopping-cart-form-changed.guard';
import { MessagesFormChangedGuard } from './guards/messages-form-changed.guard';
import { ImagesFormChangedGuard } from './guards/images-form-changed.guard';
import { TicketCategoriesComponent } from './pages/cms/ticket-categories/ticket-categories.component';
import { TicketCategoryFormChangedGuard } from './guards/ticket-category-form-changed.guard';
import { OnDemandTicketConfigurationPage } from './pages/shop/on-demand-ticket-configuration-page/on-demand-ticket-configuration-page.component';
import { OnDemandTicketConfigurationOptionsComponent } from './pages/shop/on-demand-ticket-configuration-page/on-demand-ticket-configuration-options/on-demand-ticket-configuration-options.component';
import { OnDemandTicketConfigurationReservationComponent } from './pages/shop/on-demand-ticket-configuration-page/on-demand-ticket-configuration-reservation/on-demand-ticket-configuration-reservation.component';
import { OnDemandTicketConfigurationPassengerDataComponent } from './pages/shop/on-demand-ticket-configuration-page/on-demand-ticket-configuration-passenger-data/on-demand-ticket-configuration-passenger-data.component';
import { OnDemandTicketConfigurationPaymentComponent } from './pages/shop/on-demand-ticket-configuration-page/on-demand-ticket-configuration-payment/on-demand-ticket-configuration-payment.component';
import { OnDemandTicketConfigurationCheckoutComponent } from './pages/shop/on-demand-ticket-configuration-page/on-demand-ticket-configuration-checkout/on-demand-ticket-configuration-checkout.component';
import { AccountFellowTravelersPageComponent } from './pages/shop/account/account-fellow-travelers-page/account-fellow-travelers-page.component';
import { LicensePageComponent } from './pages/cms/license/license-page.component';
import { LicenseFormChangedGuard } from './guards/license-form-changed.guard';
import { licenseGuard } from './guards/license.guard';
import { SortimentPageComponent } from './pages/cms/sortiment/sortiment-page.component';
import { AppearancePageComponent } from './pages/cms/appearance-page/appearance-page.component';
import { AppearancePageGuard } from './guards/appearance-page.guard';
import { CorporateDesignPageGuard } from './guards/corporate-design-page.guard';

export const APP_ROUTES: Route[] = [
  {
    path: ERoute.accessDenied,
    component: CmsAccessDeniedPageComponent,
  },
  { path: ERoute.error, component: ErrorPageComponent },
  {
    path: ERoute.cms,
    component: CmsPageComponent,
    canActivateChild: [userIsAuthenticatedGuard, UserIsCmsUserGuard],
    children: [
      {
        path: '',
        redirectTo: ERoute.incidents,
        pathMatch: 'full',
      },
      {
        path: ERoute.admin,
        children: [
          {
            path: '',
            redirectTo: ERoute.orders,
            pathMatch: 'full',
          },
          {
            path: ERoute.orders,
            component: OrdersPageComponent,
            canActivate: [
              UserIsAdminGuard,
              licenseGuard([
                LICENSE_KEYS.DirectSale,
                LICENSE_KEYS.Subscription,
              ]),
            ],
          },
          {
            path: ERoute.users,
            component: UsersPageComponent,
            canActivate: [UserIsAdminGuard, licenseGuard(LICENSE_KEYS.Base)],
          },
        ],
      },
      {
        path: ERoute.header,
        component: HeaderPageComponent,
        canDeactivate: [HeaderFormChangedGuard],
        canActivate: [
          licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
        ],
      },
      {
        path: ERoute.banner,
        component: BannerPageComponent,
        canDeactivate: [BannerFormChangedGuard],
        canActivate: [
          licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
        ],
      },
      {
        path: ERoute.footer,
        component: FooterPageComponent,
        canDeactivate: [FooterFormChangedGuard],
        canActivate: [
          licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
        ],
      },
      {
        path: ERoute.corporateDesign,
        component: CorporateDesignPageComponent,
        canActivate: [licenseGuard(LICENSE_KEYS.Base)],
        canDeactivate: [CorporateDesignPageGuard],
      },
      {
        path: ERoute.appearance,
        component: AppearancePageComponent,
        canActivate: [
          licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
        ],
        canDeactivate: [AppearancePageGuard],
      },
      {
        path: `${ERoute.configuration}/:licenseKey`,
        component: ConfigurationPageComponent,
        canActivate: [
          UserIsAdminGuard,
          licenseGuard(route => route.paramMap.get('licenseKey')),
        ],
        canDeactivate: [ConfigurationFormChangedGuard],
      },
      {
        path: ERoute.license,
        component: LicensePageComponent,
        canDeactivate: [LicenseFormChangedGuard],
      },
      {
        path: ERoute.texts,
        children: [
          {
            path: '',
            redirectTo: ERoute.web,
            pathMatch: 'full',
          },
          {
            path: ERoute.web,
            component: TextsForWebPageComponent,
            canDeactivate: [WebTextsFormChangedGuard],
            canActivate: [
              licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
            ],
          },
          {
            path: ERoute.app,
            component: TextsForAppComponent,
            canDeactivate: [AppTextsFormChangedGuard],
            canActivate: [
              licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.App),
            ],
          },
        ],
      },
      {
        path: ERoute.userFeedback,
        component: UserFeedbackPageComponent,
        canDeactivate: [MessagesFormChangedGuard],
        canActivate: [licenseGuard(LICENSE_KEYS.Base)],
      },
      {
        path: ERoute.images,
        component: ImagePageComponent,
        canDeactivate: [ImagesFormChangedGuard],
        canActivate: [licenseGuard(LICENSE_KEYS.Base)],
      },
      {
        path: ERoute.languages,
        component: LanguagePageComponent,
        canActivate: [UserIsAdminGuard, licenseGuard(LICENSE_KEYS.Base)],
        canDeactivate: [LanguageFormChangedGuard],
      },
      {
        path: ERoute.sortiment,
        component: SortimentPageComponent,
        canActivate: [
          licenseGuard([LICENSE_KEYS.DirectSale, LICENSE_KEYS.Subscription]),
        ],
      },
      {
        path: `${ERoute.ticketCategories}`,
        component: TicketCategoriesComponent,
        canDeactivate: [TicketCategoryFormChangedGuard],
        canActivate: [
          licenseGuard([LICENSE_KEYS.DirectSale, LICENSE_KEYS.Subscription]),
        ],
      },
      {
        path: ERoute.incidents,
        component: IncidentMonitorPageComponent,
      },
      {
        path: ERoute.general,
        children: [
          {
            path: ERoute.startPage,
            component: StartPageComponent,
            canDeactivate: [StartPageFormChangedGuard],
            canActivate: [
              licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
            ],
          },
          {
            path: `${ERoute.startPage}/${ERoute.edit}/:sectionId/:cardId`,
            component: StartPageCardEditPageComponent,
            canDeactivate: [StartPageEditCardFormChangedGuard],
            canActivate: [
              licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
            ],
          },
          {
            path: ERoute.shoppingCart,
            component: ShoppingCartPageComponent,
            canDeactivate: [ShoppingCartFormChangedGuard],
            canActivate: [
              licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
            ],
          },
        ],
      },
    ],
  },
  {
    path: '',
    component: ShopPageComponent,
    canActivate: [licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web)],
    children: [
      { path: '', component: LandingPageComponent },
      {
        path: 'inputs', //temporary page for testing
        component: FormInputsDisplayComponent,
      },
      {
        path: 'buttons', //temporary page for testing
        component: ButtonDisplayComponent,
      },
      {
        path: ERoute.subscriptions,
        component: SubscriptionTicketsPageComponent,
        canActivate: [
          licenseGuard(LICENSE_KEYS.Subscription, EConfigurationChannel.Web),
        ],
      },
      {
        path: ERoute.subscriptionConfiguration,
        component: SubscriptionConfigurationPageComponent,
        canActivateChild: [
          licenseGuard(LICENSE_KEYS.Subscription, EConfigurationChannel.Web),
        ],
        children: [
          {
            path: `${ERoute.options}/:ticketName`,
            component: SubscriptionOptionConfigurationPage,
            children: [
              {
                path: '',
                redirectTo: `${ERoute.mask}/0`,
                pathMatch: 'full',
              },
              {
                path: `${ERoute.mask}/:step`,
                component: SubscriptionMaskStepComponent,
              },
              {
                path: ERoute.payment,
                component: SubscriptionPaymentStepComponent,
              },
            ],
          },
        ],
      },
      {
        path: `${ERoute.subscriptionConfiguration}/:ticketName`,
        redirectTo: `${ERoute.subscriptionConfiguration}/${ERoute.options}/:ticketName`,
        pathMatch: 'full',
      },
      {
        path: ERoute.directTickets,
        component: DirectTicketsPageComponent,
        canActivate: [
          licenseGuard(LICENSE_KEYS.DirectSale, EConfigurationChannel.Web),
        ],
      },
      {
        path: ERoute.directTickets + '/recon-id/:ctx',
        component: DirectTicketsPageComponent,
        canActivate: [
          licenseGuard(LICENSE_KEYS.DirectSale, EConfigurationChannel.Web),
        ],
      },
      {
        path: ERoute.onDemandTicketConfiguration,
        component: OnDemandTicketConfigurationPage,
        canActivateChild: [
          licenseGuard(LICENSE_KEYS.OnDemand, EConfigurationChannel.Web),
        ],
        children: [
          {
            path: '',
            redirectTo: '/',
            pathMatch: 'full',
          },
          {
            path: `${ERoute.options}/:ticketName`,
            component: OnDemandTicketConfigurationOptionsComponent,
          },
          {
            path: ERoute.reservation,
            component: OnDemandTicketConfigurationReservationComponent,
          },
          {
            path: ERoute.passengerData,
            component: OnDemandTicketConfigurationPassengerDataComponent,
          },
          {
            path: ERoute.payment,
            component: OnDemandTicketConfigurationPaymentComponent,
          },
          {
            path: ERoute.checkout,
            component: OnDemandTicketConfigurationCheckoutComponent,
          },
        ],
      },
      {
        path: `${ERoute.onDemandTicketConfiguration}/:ticketName`,
        redirectTo: `${ERoute.onDemandTicketConfiguration}/${ERoute.options}/:ticketName`,
        pathMatch: 'full',
      },
      {
        path: ERoute.directTicketConfiguration,
        component: DirectTicketConfigurationPageComponent,
        canActivateChild: [
          licenseGuard(LICENSE_KEYS.DirectSale, EConfigurationChannel.Web),
        ],
        children: [
          {
            path: '',
            redirectTo: '/',
            pathMatch: 'full',
          },
          {
            path: ERoute.personalData,
            component: DirectTicketPersonalDataPageComponent,
          },
          {
            path: ERoute.ticketOwnerData,
            component: DirectTicketOwnerDataPageComponent,
          },
          {
            path: ERoute.checkout,
            component: DirectTicketCheckoutPageComponent,
          },
          {
            path: ERoute.payment,
            component: DirectTicketPaymentPageComponent,
          },
          {
            path: `${ERoute.options}/:ticketName`,
            component: DirectTicketOptionConfigurationPage,
          },
        ],
      },
      {
        path: `${ERoute.directTicketConfiguration}/:ticketName`,
        redirectTo: `${ERoute.directTicketConfiguration}/${ERoute.options}/:ticketName`,
        pathMatch: 'full',
      },
      {
        path: ERoute.account,
        component: AccountPageComponent,
        canActivateChild: [
          userIsAuthenticatedGuard,
          licenseGuard(LICENSE_KEYS.Base, EConfigurationChannel.Web),
        ],
        children: [
          {
            path: '',
            redirectTo: ERoute.info,
            pathMatch: 'full',
          },
          {
            path: ERoute.info,
            component: AccountInfoPageComponent,
          },
          {
            path: ERoute.delete,
            component: AccountDeletePageComponent,
          },
          {
            path: ERoute.payment,
            component: AccountPaymentPageComponent,
          },
          {
            path: ERoute.fellowTravelers,
            component: AccountFellowTravelersPageComponent,
          },
          {
            path: ERoute.orders,
            component: AccountOrdersPageComponent,
          },
        ],
      },
    ],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
